import { useEffect, useState } from "react";
import SVG from "../../SVG";

export default function ThemeToggleButton() {
  const [isDark, setIsDark] = useState(
    localStorage.getItem("theme") === "dark",
  );

  // Optional: sync with localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem("theme");
    if (stored) {
      const shouldBeDark = stored === "dark";
      document.documentElement.classList.toggle("dark", shouldBeDark);
      setIsDark(shouldBeDark);
    } else {
      document.documentElement.classList.add("dark");
      localStorage.setItem("theme", "dark");
      setIsDark(true);
    }
  }, []);
  function setThemeColor(color) {
          try {
            let meta = document.querySelector('meta[name="theme-color"]');
            if (!meta) {
              meta = document.createElement('meta');
              meta.setAttribute('name', 'theme-color');
              document.head.appendChild(meta);
            }
            meta.setAttribute('content', color);
            // visual fallback for browsers that ignore theme-color
            document.documentElement.style.backgroundColor = color;
          } catch (e) {
            // ignore
          }
        }
  const handleToggle = () => {
    const html = document.documentElement;
    const nextIsDark = !isDark;

    html.classList.toggle("dark", nextIsDark);
    localStorage.setItem("theme", nextIsDark ? "dark" : "light");
    setIsDark(nextIsDark); // 🔥 this triggers re-render
    setThemeColor(nextIsDark ? "#2a404f" : "#f6f6f6");
  };

  return (
    <button type="button" className="p-2 outline-none" onClick={handleToggle}>
      <div
        className={`transition-all duration-300 transform ${
          isDark ? "rotate-180 opacity-100" : "rotate-0 opacity-100"
        }`}
      >
        {isDark ? (
          <SVG name="moon" classname="drop-shadow-md cursor-pointer size-5" />
        ) : (
          <SVG name="sun" classname="drop-shadow-md cursor-pointer size-5" />
        )}
      </div>
    </button>
  );
}
